class ProductTemplate extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.calculateShipping();

        this.querySelectorAll(".faq-item-title").forEach((button) => {
            button.addEventListener("click", this.toggleFaqItem.bind(this));
        });

        // ✅ Enable add-to-cart that redirects to checkout
        this.handleAddToCartRedirect();

        // Onglet pack (DUO) : switch LOCAL (ne bascule pas les autres sections)
        this.setupPackTabs();

        // Sous-switcher RISE/MUSE (scents + notes) dans un panneau pack
        this.setupPackContentSwitch();
    }

    toggleFaqItem(e) {
        e.currentTarget
            .querySelector(".faq-close")
            .classList.toggle("faq-display-none");

        e.currentTarget.parentNode.classList.toggle("faq-item-active");

        const item = e.currentTarget.parentNode.querySelector(".faq-item-text");

        item.slideToggle("250");
    }

    calculateShipping() {
        if (this.querySelector(".sidecart-form__icon")) {
            let shipping_date = new Date(new Date().getTime());
            let shipping_delay = parseInt(
                this.querySelector(".sidecart-form__icon").getAttribute("data-shipping-delay")
            );

            for (var i = 0; i < shipping_delay; i++) {
                shipping_date.setDate(shipping_date.getDate() + 1);
                if (shipping_date.getDay() == 6) {
                    shipping_date.setDate(shipping_date.getDate() + 2);
                }
                if (shipping_date.getDay() == 0) {
                    shipping_date.setDate(shipping_date.getDate() + 1);
                }
            }

            let shipping_date_format = shipping_date.toLocaleDateString("en-EN", {
                weekday: "long",
                day: "numeric",
                month: "long",
            });

            for (
                let i = 0;
                i < document.querySelectorAll(".sidecart-form__icon").length;
                i++
            ) {
                let html = document.querySelectorAll(".sidecart-form__icon")[i]
                    .innerHTML;
                if (html.indexOf("[date]") > -1) {
                    document.querySelectorAll(".sidecart-form__icon")[i].innerHTML =
                        html.replace("[date]", shipping_date_format);
                }
            }
        }
    }

    // Add-to-cart -> vide le panier puis redirige checkout (via AuraCheckout partagé)
    handleAddToCartRedirect() {
        const forms = this.querySelectorAll('.product-form__form--form');
        if (!forms.length) return;

        forms.forEach((form) => {
            form.addEventListener('submit', (e) => {
                e.preventDefault();
                const btn = form.querySelector('button[type="submit"]');
                if (window.AuraCheckout) {
                    window.AuraCheckout.addAndCheckout({ form: form, button: btn });
                } else {
                    // Fallback : soumission native si le helper n'est pas chargé
                    form.submit();
                }
            });
        });
    }

    // Onglet pack (DUO) : bascule uniquement les panneaux de CE product-template,
    // sans émettre product:switch (les autres sections ne bougent pas).
    setupPackTabs() {
        const packTabs = this.querySelectorAll('[data-pack-switch]');
        if (!packTabs.length) return;

        const panels = this.querySelectorAll('.product-template__panel');
        const tabs = this.querySelectorAll('.product-template__tab');

        const showLocal = (handle) => {
            // Le pack devient le "produit actif" : sans ça, product-switch.js
            // annule le retour vers l'onglet du dernier produit unique affiché
            // (garde-fou data-active-product === handle). Aucun product:switch
            // n'est émis, donc les autres sections ne bougent pas.
            document.documentElement.setAttribute('data-active-product', handle);
            panels.forEach((panel) => {
                const match = panel.getAttribute('data-product-panel') === handle;
                panel.toggleAttribute('hidden', !match);
                if (match) {
                    const accent = panel.getAttribute('data-accent');
                    const accentText = panel.getAttribute('data-accent-text');
                    if (accent) document.documentElement.style.setProperty('--product-accent', accent);
                    if (accentText) document.documentElement.style.setProperty('--product-accent-text', accentText);
                    requestAnimationFrame(() => {
                        panel.querySelectorAll('.swiper').forEach((s) => { if (s.swiper) s.swiper.update(); });
                    });
                }
            });
            tabs.forEach((t) => {
                const on = t.getAttribute('data-pack-switch') === handle;
                t.classList.toggle('is-active', on);
            });
        };

        packTabs.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                showLocal(btn.getAttribute('data-pack-switch'));
            });
        });

        // Sur un switch GLOBAL (RISE/MUSE via carousel ou tab), l'onglet pack
        // doit perdre son état actif (les panneaux sont gérés par apply() global).
        document.addEventListener('product:switch', () => {
            packTabs.forEach((t) => t.classList.remove('is-active'));
        });
    }

    // Sous-switcher RISE/MUSE : change Main scents + Notes dans le panneau pack.
    setupPackContentSwitch() {
        const scentTabs = this.querySelectorAll('[data-scent-tab]');
        if (!scentTabs.length) return;

        scentTabs.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                const handle = btn.getAttribute('data-scent-tab');
                const panel = btn.closest('.product-template__panel') || this;

                panel.querySelectorAll('[data-scent-tab]').forEach((t) => {
                    t.classList.toggle('is-active', t.getAttribute('data-scent-tab') === handle);
                });
                ['data-scent-group', 'data-note-group', 'data-intensity-group', 'data-ingredient-group'].forEach((attr) => {
                    panel.querySelectorAll('[' + attr + ']').forEach((g) => {
                        g.toggleAttribute('hidden', g.getAttribute(attr) !== handle);
                    });
                });
            });
        });
    }
}

customElements.define('product-template', ProductTemplate);
